// ----------------------------------------------------------------------------
// Component: iamProductDescription <iam-product-description>
// ----------------------------------------------------------------------------
// Listens for variant changes and updates the product description to match the
// selected variant's short description metafield.
// ----------------------------------------------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
class iamProductDescription extends HTMLElement {
  connectedCallback() {
    var _this$descriptionElem, _this$iamForm, _this$iamForm$getCurr;
    this.descriptionElement = this.querySelector('.description');
    this.defaultDescription = ((_this$descriptionElem = this.descriptionElement) === null || _this$descriptionElem === void 0 ? void 0 : _this$descriptionElem.innerHTML) || '';
    this.iamForm = this.closest('iam-product-form') || document.querySelector('iam-product-form');
    this.variantDescriptions = this.getVariantDescriptions();
    if (!this.descriptionElement) {
      console.warn('iam-product-description: missing .description element.');
      return;
    }

    // Subscribe to variant changes scoped to the current product form
    iamotaEventHandler.subscribe('productForm:variant:changed', this.onVariantChange.bind(this), {
      context: this.iamForm,
      source: "product-description.js"
    });

    // Sync description with the current variant on load (if available)
    var currentVariant = (_this$iamForm = this.iamForm) === null || _this$iamForm === void 0 || (_this$iamForm$getCurr = _this$iamForm.getCurrentVariant) === null || _this$iamForm$getCurr === void 0 ? void 0 : _this$iamForm$getCurr.call(_this$iamForm);
    if (currentVariant) {
      this.updateDescription(currentVariant);
    }
  }
  onVariantChange(_ref) {
    var _iamProductForm$getCu;
    var {
      iamProductForm,
      variant
    } = _ref;
    // Ignore updates from other product forms
    if (this.iamForm && iamProductForm && this.iamForm !== iamProductForm) return;
    var currentVariant = (iamProductForm === null || iamProductForm === void 0 || (_iamProductForm$getCu = iamProductForm.getCurrentVariant) === null || _iamProductForm$getCu === void 0 ? void 0 : _iamProductForm$getCu.call(iamProductForm)) || variant;
    this.updateDescription(currentVariant);
  }
  updateDescription(variant) {
    var shortDescription = this.getVariantShortDescription(variant);
    this.descriptionElement.innerHTML = shortDescription !== null && shortDescription !== void 0 ? shortDescription : this.defaultDescription;
  }
  getVariantDescriptions() {
    var descriptionsElement = this.querySelector('[data-variant-short-descriptions]');
    if (!(descriptionsElement !== null && descriptionsElement !== void 0 && descriptionsElement.textContent)) return {};
    try {
      return JSON.parse(descriptionsElement.textContent);
    } catch (error) {
      console.warn('iam-product-description: unable to parse variant descriptions.', error);
      return {};
    }
  }
  normalizeShortDescription(value) {
    if (value == null) return null;
    if (typeof value === 'object') {
      return this.normalizeShortDescription(value.value);
    }
    if (typeof value === 'string' && value.trim() === '') {
      return null;
    }
    return value;
  }
  getVariantShortDescription(variant) {
    var _variant$custom, _variant$custom2, _variant$metafields, _variant$metafields2, _variant$short_descri, _this$variantDescript, _shortDescriptions$ma;
    if (!variant) return null;
    var shortDescriptions = [(_variant$custom = variant.custom) === null || _variant$custom === void 0 || (_variant$custom = _variant$custom.short_description) === null || _variant$custom === void 0 ? void 0 : _variant$custom.value, (_variant$custom2 = variant.custom) === null || _variant$custom2 === void 0 ? void 0 : _variant$custom2.short_description, (_variant$metafields = variant.metafields) === null || _variant$metafields === void 0 || (_variant$metafields = _variant$metafields.content) === null || _variant$metafields === void 0 || (_variant$metafields = _variant$metafields.short_description) === null || _variant$metafields === void 0 ? void 0 : _variant$metafields.value, (_variant$metafields2 = variant.metafields) === null || _variant$metafields2 === void 0 || (_variant$metafields2 = _variant$metafields2.content) === null || _variant$metafields2 === void 0 ? void 0 : _variant$metafields2.short_description, (_variant$short_descri = variant.short_description) === null || _variant$short_descri === void 0 ? void 0 : _variant$short_descri.value, variant.short_description, (_this$variantDescript = this.variantDescriptions) === null || _this$variantDescript === void 0 ? void 0 : _this$variantDescript[String(variant.id)]];
    return (_shortDescriptions$ma = shortDescriptions.map(value => this.normalizeShortDescription(value)).find(value => value !== null)) !== null && _shortDescriptions$ma !== void 0 ? _shortDescriptions$ma : null;
  }
}
customElements.define('iam-product-description', iamProductDescription);